import { requirementConditionStatusOptions } from 'modules/analyse/constants/requirementConditionOptions';
import { AutomationFormItem } from 'modules/analyse/types/AutomationFormItem';

export const getRequirementConditionsAvailableOptions = (
  values: AutomationFormItem[]
) => {
  const requirementConditions = values
    .map((item) => item.requirementConditions)
    .flat();

  const candidateStatusesUsed = requirementConditions
    .map((condition) => condition.candidateStatus)
    .filter(Boolean);

  const candidateStatuses = requirementConditionStatusOptions.filter(
    (status) => !candidateStatusesUsed.includes(status)
  );

  return {
    candidateStatusesAvailableOptions: candidateStatuses
  };
};
